import { Component, OnInit, QueryList, ElementRef, Inject, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable, } from '@angular/material/table';

import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';

import { DatePipe } from '@angular/common';

import { DedicatsService } from '../../notes/dedicats.service';
import * as moment from 'moment';

export interface DedicatsMesElement {
  codi: string;
  January : number;
  February : number;
  March : number;
  April: number;
  May: number;
  June: number;
  July: number;
  August: number;
  September: number;
  October: number;
  November: number;
  December: number;
  Total: number;
  titol : string;
  ambit_proposta: string;
}

const ELEMENT_DATA: DedicatsMesElement[] = <any>[];
const idemCodi = (a, b) => a.codi === b.codi && a.display === b.display;
 
@Component({
  selector: 'dialog-dedicats-mes',
  templateUrl: './dialog.component.dedicats-mes.html',
  styleUrls: ['./dialog.component.dedicats-mes.scss'],
  providers: [ DedicatsService, DatePipe ]
})

export class DialogDedicatsMes implements OnInit {
   public showAsyncProgress: boolean = false;
   public userInfo: any = {};
   public dedicacionsMesData: Array<DedicatsMesElement> = [];
   public editDedicacionsMesData = Object.assign({});
   public tipus: string = "Treballs";
   public year: string = '';
   public mesActual: string = "";

   public displayedColumns: string[] = ['codi', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'Total'];
   public dataSource = ELEMENT_DATA;
   public dataOrigSource = ELEMENT_DATA;
   public dataPropSource = ELEMENT_DATA;

   @ViewChild('table') table: MatTable<DedicatsMesElement>;
   @ViewChild('table1') table1: MatTable<DedicatsMesElement>;
//   @ViewChild(MatTable) table!: QueryList<MatTable<DedicatsMesElement>>;

  constructor(public translate: TranslateService, public languageService: LanguageService, private tokenStorage: TokenStorageService, private dedicatsService: DedicatsService, public dialogRef: MatDialogRef<DialogDedicatsMes>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.userInfo = data;
    this.year = moment().year().toString();
    this.mesActual = moment().format('MMMM');
  }

  ngOnInit() {this.filtrar();}

  desar(): void {
   this.showAsyncProgress = true;

   this.dataOrigSource = this.dataSource.map(item => {
     let auxItem = this.dataOrigSource.find(orgItem => item["codi"] == orgItem["codi"]);
     for(let obj in item)//99999 -> desar un 0 a les hores (realment fa el delete i no l'update al servidor)
        if(obj !== 'codi') auxItem[obj] = (item[obj] == auxItem[obj]?0:(item[obj]==0?99999:item[obj]));
     return auxItem;
   });
   this.dataOrigSource = this.dataOrigSource.slice(0,-1);
   if(this.dataOrigSource[this.dataOrigSource.length-1]['codi'] == "Propostes *" ||
      this.dataOrigSource[this.dataOrigSource.length-1]['codi'] == "Treballs *")
           this.dataOrigSource = this.dataOrigSource.slice(0,-1);

   this.dedicatsService.updateDedicacionsMes(
     this.dataOrigSource, this.userInfo.id, this.year, (this.tipus == "Treballs"?0:1))
     .subscribe(data => { this.showAsyncProgress = false;   this.filtrar(); });
  }

  filtrar(){
    this.dataSource = [];
    this.dataPropSource = [];
    this.dedicacionsMesData = [];
    this.dedicatsService.getDedicacionsMes(
  this.userInfo.id,
  this.year,
  (this.tipus == "Treballs" ? 0 : 1)
).subscribe(
  data => {

    // Netejem les dades anteriors
    this.dataSource = [];
    this.dataPropSource = [];

    // Files de dedicacions
    data.forEach(item => {
      this.dataSource.push({
        codi: item.codi,
        January: Number(item.January) || 0,
        February: Number(item.February) || 0,
        March: Number(item.March) || 0,
        April: Number(item.April) || 0,
        May: Number(item.May) || 0,
        June: Number(item.June) || 0,
        July: Number(item.July) || 0,
        August: Number(item.August) || 0,
        September: Number(item.September) || 0,
        October: Number(item.October) || 0,
        November: Number(item.November) || 0,
        December: Number(item.December) || 0,
        Total: Number(item.Total) || 0,
        titol: item.titol || '',
        ambit_proposta: item.ambit_proposta || ''
      });
    });

    // Eliminem el Total que ve del backend i el calculem nosaltres,
    // si volem tenir-lo sempre al final
    if (this.dataSource.length > 0 &&
        this.dataSource[this.dataSource.length - 1].codi == 'Total') {

      this.dataSource.pop();
    }

    // Calculem la fila Total
    let totalCols = {
      codi: 'Total',
      January: 0,
      February: 0,
      March: 0,
      April: 0,
      May: 0,
      June: 0,
      July: 0,
      August: 0,
      September: 0,
      October: 0,
      November: 0,
      December: 0,
      Total: 0,
      titol: '',
      ambit_proposta: ''
    };

    this.dataSource.forEach(item => {
      totalCols.January += Number(item.January) || 0;
      totalCols.February += Number(item.February) || 0;
      totalCols.March += Number(item.March) || 0;
      totalCols.April += Number(item.April) || 0;
      totalCols.May += Number(item.May) || 0;
      totalCols.June += Number(item.June) || 0;
      totalCols.July += Number(item.July) || 0;
      totalCols.August += Number(item.August) || 0;
      totalCols.September += Number(item.September) || 0;
      totalCols.October += Number(item.October) || 0;
      totalCols.November += Number(item.November) || 0;
      totalCols.December += Number(item.December) || 0;
      totalCols.Total += Number(item.Total) || 0;
    });

    this.dataSource.push(totalCols);

    // Guardem una còpia de les dades originals
    this.dataOrigSource = [];
    this.dataSource.forEach(val =>
      this.dataOrigSource.push(Object.assign({}, val))
    );

    this.table.renderRows();
    this.table1.renderRows();

  },
  error => console.log(error)
  );
}

  close(): void {
    this.dialogRef.close(null);
  }

}
